import React, { useEffect, useState } from 'react';
import { useApproveStockMutation, useOrderByIdQuery } from '../../../Store/Apis/bookingApi';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../Components/Loader/Loader';
import Error from '../../../Components/Error/Error';
import { useSelector } from 'react-redux';
import { isPermissionGranted } from '../../../Hooks/permissionsMiddleware';
import { useTaxPercentageQuery } from '../../../Store/Apis/toolsApi';
import formatDate from '../../../Hooks/formatDate';
import toast from 'react-hot-toast';

const StockApprovalDetails = () => {
    const user = useSelector((state)=> state.auth.user)
    const location = useLocation();
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('id');
    
    const orderByIdApi = useOrderByIdQuery({
        keyID: orderId
    }, { skip: !orderId });

    const taxPercentageApi = useTaxPercentageQuery()


    // Filter dropdown items based on the current status
    const [selectedStatus, setSelectedStatus] = useState({})
    const taxPercentage = Number(taxPercentageApi?.data?.data?.masterValue) || 0; // Get the tax value or default to 0
    const taxAmount = orderByIdApi?.data?.data[0].subTotal * taxPercentage / 100;
    const subtotal = !taxPercentageApi.isSuccess 
    ? orderByIdApi?.data?.data[0].subTotal 
    : orderByIdApi?.data?.data[0].subTotal + taxAmount; // Using totalAmount as the subtotal

    const grossTotal = Number(subtotal) - Number(orderByIdApi?.data?.data[0]?.discount)
    
    const [approveStockApi] = useApproveStockMutation()
    const approveStock = () => {
        approveStockApi({
            orderID: orderId,
            adminID: user.id,
            approvalState: 1
        }).then((res)=>{
            console.log(res.data)
            if(res.data.status === 200){
                toast.success(res?.data?.message, { duration: 7000 });
                navigate('/stock-approval');
            }
        })
    }

    useEffect(() => {
        setSelectedStatus({
            id: orderByIdApi?.data?.data[0].statusID,
            description: orderByIdApi?.data?.data[0].statusDescription
        })
    }, [orderByIdApi.isSuccess])
    
    return (
        <div>
            <div className="row align-items-center justify-content-between mb-2">
                <div className="col">
                    <h5 className="fw-500 text-white">Order Details {orderByIdApi.isSuccess && `- ${orderByIdApi.data.data[0].orderNumber}`}</h5>
                </div>
            </div>            
            {orderByIdApi.isError && (
                <div className="card">
                    <div className="card-body">
                        <Error/>
                    </div>
                </div>
            )}
            {orderByIdApi.isLoading && (
                <div className="card">
                    <div className="card-body">
                        <Loader height="500px"/>
                    </div>
                </div>
            )}
            {
                orderByIdApi.isSuccess && (
                    <>
                        <div className="row">
                            <div className="col-md-9" id="invoiceToPrint">
                                <div className="card mb-4">
                                    <div className="card-header p-4">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-7">
                                                <h5 className="text-uppercase fw-600 mb-1">{orderByIdApi.data.data[0].outletName}</h5>
                                                <p className="text-sm mb-0">{orderByIdApi.data.data[0].outletPhone}</p>
                                                <p className='text-sm mb-0'>{orderByIdApi.data.data[0].outletAddress}</p>
                                            </div>
                                            <div className="col-lg-4 col-md-5">
                                                <h6 className="fw-bold">
                                                    <span>Order ID -</span>
                                                    <span className="ms-2">{orderByIdApi.data.data[0].orderNumber}</span>
                                                </h6>
                                                <p className="text-sm mb-1">
                                                    <span>Order Date:</span>
                                                    <span className="fw-600 ms-2">{formatDate(orderByIdApi.data.data[0].orderDate)}</span>
                                                </p>
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <span className="text-sm fw-600">Order Status</span>
                                                    </div>
                                                    <span className='badge badge-primary mb-0 text-xxs'>
                                                        {selectedStatus.description}
                                                    </span>                                                 
                                                </div>                                        
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="table-responsive">
                                            <table className="table align-items-center mb-0">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th className="text-uppercase text-secondary text-xs opacity-7 px-3">#</th>
                                                        <th className="text-uppercase text-secondary text-xs opacity-7 px-0">Product/Service Name</th>
                                                        <th className="text-uppercase text-secondary text-xs opacity-7 px-0">Rate</th>
                                                        <th className="text-uppercase text-secondary text-xs opacity-7 px-0 text-center">QTY</th>
                                                        <th className="text-uppercase text-secondary text-xs opacity-7 px-0">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orderByIdApi?.data?.data[0]?.serviceTypeAndName?.map((service, index) => (
                                                        <tr key={service.serviceID}>
                                                            <td><p className="text-sm mb-0 px-3">{index + 1}</p></td>
                                                            <td className='px-0'>
                                                                <div className="d-flex flex-column">
                                                                    <h6 className="mb-0 text-sm">{service.serviceName}</h6>
                                                                    <p className='mb-0 text-xs'>{service.productServiceName}</p>
                                                                    <p className='mb-0 text-xs'>{service.serviceCode}</p>
                                                                </div>
                                                            </td>
                                                            <td className='px-0'><p className="text-sm mb-0">R {service.rate}.00</p></td>
                                                            <td className="px-0">
                                                                <p className="text-sm mb-0 text-center">
                                                                    {service.quantity} 
                                                                    <br />
                                                                    {
                                                                        service.typeID === 1 && (
                                                                            service.stockQuantity > 0 ? (
                                                                                <span className='badge badge-success'>Available: {service.stockQuantity} </span>
                                                                            ) : (
                                                                                <span className='badge badge-danger'>No Stock </span>
                                                                            )
                                                                        )
                                                                    }
                                                                </p>   
                                                            </td>
                                                            <td className='px-0'><p className="text-sm mb-0">R {service.total}.00</p></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="card-footer px-4">
                                        <div className="row">
                                            <div className="col-md-8 mb-3">
                                                <h6 className="mb-2 fw-500">Invoice To:</h6>
                                                <h6 className="mb-1 fw-500 text-sm">{orderByIdApi.data.data[0].customerName}</h6>
                                                <p className="text-sm mb-0">{orderByIdApi.data.data[0].customerNumber}</p>
                                                <p className="text-sm mb-3">{orderByIdApi.data.data[0].email}</p>
                                                <p className="text-sm mb-0">GST No: {orderByIdApi.data.data[0].gstNo}</p>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <h6 className="fw-500 mb-2">Payment Details:</h6>
                                                <div className="row mb-50 align-items-center">
                                                    <div className="col text-sm">Sub Total:</div>
                                                    <div className="col-auto text-sm">R {orderByIdApi.data.data[0].subTotal.toFixed(2)}</div>
                                                </div>
                                                <div className="row mb-50 align-items-center">
                                                    <div className="col text-sm">Discount:</div>
                                                    <div className="col-auto text-sm">R {orderByIdApi.data.data[0].discount.toFixed(2)}</div>
                                                </div>
                                                <div className="row mb-50 align-items-center">
                                                    <div className="col text-sm">Vat ({taxPercentage}%):</div>
                                                    <div className="col-auto text-sm">R {taxAmount.toFixed(2)}</div>
                                                </div>
                                                <div className="row align-items-center">
                                                    <div className="col text-sm fw-600">Gross Total:</div>
                                                    <div className="col-auto text-sm text-dark fw-600">R {grossTotal.toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card mb-4">
                                    <div className="card-body p-4">
                                        <p className="text-sm mb-0">
                                            <span>Order Created By</span> <br />
                                            <span className="fw-600">{orderByIdApi.data.data[0].customerName}</span>
                                        </p>

                                        {/* TECHNICIAN Details */}
                                        {
                                            ((Number(orderByIdApi?.data?.data[0].statusID) === 1 || Number(orderByIdApi?.data?.data[0].statusID) === 3)) && (
                                                <>
                                                    <h6 className='mb-0 fw-500'>Technician Details</h6>
                                                    <p class="text-sm mb-1">
                                                        <span>Name :</span> <span class="fw-600">{orderByIdApi.data.data[0].technicianName}</span>
                                                    </p>
                                                    <p class="text-sm mb-3">
                                                        <span>PH :</span> <span class="fw-600">7986543210</span>
                                                    </p>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>
                            

                                {
                                    (orderByIdApi?.data?.data[0].adminConfirmationStatus !== 1) && (
                                        <div class="card mb-4">
                                            <div class="card-body p-4">
                                                <div class="row gy-2">
                                                    <div class="col-12">
                                                        <button
                                                            className="btn btn-icon btn-success mb-0 w-100"
                                                            onClick={approveStock}
                                                        >
                                                            Confirm Stock Requsition
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </>
                )
            }
        </div>
    );
};

export default StockApprovalDetails;
